import React from "react";
import PropTypes from "prop-types";
import { MCImage } from "./MCImage";
import { Wrapper } from "./Wrapper";
import { ModalWindow } from "./ModalWindow";
import { Tooltips } from "./Tooltips";
import i18next from "./locale/i18next";

import "./style.scss";
import { I18nextProvider } from "react-i18next";

const i18n = i18next;

const changeLang = (lang) => {
  i18n.changeLanguage(lang);
};

export const MCStateContext = React.createContext();

export function MicrocentrifugeNew(props) {
  const [hover, setHover] = React.useState(false);

  React.useEffect(() => {
    props.lang && changeLang(props.lang);
  }, [props.lang]);

  return (
    <I18nextProvider i18n={i18n}>
      <MCStateContext.Provider
        value={{
          running: props.running,
          pulsing: props.pulsing,
          balanced: props.balanced,
          isLidOpen: props.isLidOpen,
          playbackComplete: props.playbackComplete,
        }}
      >
        <Wrapper className="microcentrifugeNew">
          <Tooltips
            setModalView={props.setModalView}
            toggleLid={props.toggleLid}
            slots={props.slots}
            openModal={props.openModal}
            removeSlotItems={props.removeSlotItems}
            setHover={setHover}
            hover={hover}
          />
          <Wrapper className="microcentrifugeNew_real">
            <MCImage
              toggleLid={props.toggleLid}
              openModal={props.openModal}
              setView={props.setModalView}
              slots={props.slots}
              onItemDropCentrifuge={props.onItemDropCentrifuge}
              setHover={setHover}
            />
            <ModalWindow
              isOpen={props.isModalOpen}
              closeModal={props.closeModal}
              currentTab={props.modalView}
              toggleLid={props.toggleLid}
              setCurrentTab={props.setModalView}
              frontViewData={props.frontViewData}
              setRPM={props.setRPM}
              setTimer={props.setTimer}
              slots={props.slots}
              onDrop={props.onDropSlot}
              onRunCentrifuge={props.onRunCentrifuge}
              onStopCentrifuge={props.onStopCentrifuge}
              player={props.player}
              running={props.running}
              balanced={props.balanced}
              notebookExpanded={props.notebookExpanded}
            />
          </Wrapper>
        </Wrapper>
      </MCStateContext.Provider>
    </I18nextProvider>
  );
}

MicrocentrifugeNew.propTypes = {
  /**
   * specifies if centrifuge is running or not
   */
  running: PropTypes.bool,
  /**
   * tells if centrifuge is pulsing
   */
  pulsing: PropTypes.bool,
  /**
   * tells if centrifuge arrangement is balanced
   */
  balanced: PropTypes.bool,
  /**
   * tells if the centrifuge lid state is open or closed
   */
  isLidOpen: PropTypes.bool,
  /**
   * tells when animation playback of player is complete
   */
  playbackComplete: PropTypes.bool,
  /**
   * callback function to toggle microcentrifuge lid open and close
   */
  toggleLid: PropTypes.func,
  /**
   * callback function to set modal view tab (accepts values FRONT_VIEW or TOP_VIEW)
   */
  setModalView: PropTypes.func,
  /**
   * current modal view (topview or front view)
   */
  modalView: PropTypes.oneOf(["FRONT_VIEW", "TOP_VIEW"]),
  /**
   * callback function to open modal window
   */
  openModal: PropTypes.func,
  /**
   * tells if modal window is open
   */
  isModalOpen: PropTypes.bool,
  /**
   * callback function to close modal window
   */
  closeModal: PropTypes.func,
  /**
   * callback function to remove all items from slot' item can be solution(tube) or rotor
   */
  removeSlotItems: PropTypes.func,
  /**
   * gives the arrangement of slots in centrifuge
   */
  slots: PropTypes.arrayOf(
    PropTypes.shape({
      /**
       * unique id of each slots
       */
      id: PropTypes.number,
      /**
       * specifies of rotor present in slot
       */
      rotor: PropTypes.bool,
      /**
       * specifies of solution(tube) present in slot
       */
      solution: PropTypes.bool,
    })
  ),
  /**
   * callback function when item is dropped on centrifuge top section
   */
  onItemDropCentrifuge: PropTypes.func,
  /**
   * data for settings block
   */
  frontViewData: PropTypes.shape({
    settings: PropTypes.shape({
      /**
       * value for rpm block
       */
      rpmValue: PropTypes.number,
      /**
       * value for timer block
       */
      timerValue: PropTypes.instanceOf(Date),
    }),
  }),
  /**
   * callback function to run centrifuge
   */
  onRunCentrifuge: PropTypes.func,
  /**
   * callback function to stop centrifuge
   */
  onStopCentrifuge: PropTypes.func,
  /**
   * callback function to set rpm value
   */
  setRPM: PropTypes.func,
  /**
   * callback function to set timer value
   */
  setTimer: PropTypes.func,
  /**
   * returns component to be rendered as animation player
   */
  player: PropTypes.element,
  /**
   * callback function to trigger on drop at top view of centrifuge modal
   */
  onDrop: PropTypes.func,
};
